import React, { FC } from "react";
import { RasterIcon } from "components/Icon/Icon";
import { getAddonsIconsImage } from "containers/Delivery/deliveryHelper";
import { IconType } from "enums/Icon";
import { List } from "immutable";
import { requestNames } from "reduxFolder/reducers/serviceRequests";
import { DefaultItemIcon } from "../../../../../../styles/parcelsStyles";
import {
  HeadTextCompact,
  ItemCompact,
  ItemIcon,
  ItemLogo,
  ListItemCompact,
  ServiceRequestIcon,
} from "../SideAddonsInfo.styles";

interface SideAddonItemProps {
  addons: any;
  cartItem: any;
  consolidationAddons?: any;
  itemsConsolidationAddons?: any;
  activeItem: { value: string; label: string };
  onActiveItemChange: (value: any) => void;
  itemAddons: string[];
}

const SideAddonItem: FC<SideAddonItemProps> = ({
  itemAddons,
  addons,
  cartItem,
  activeItem,
  onActiveItemChange,
}) => {
  const filteredItemAddons = itemAddons.filter((x) =>
    addons.some((a: any) => a.get("id") === x),
  );
  const allAddons = addons.size ? List(addons) : List();
  const logoUrl = cartItem.get("emblem_thumb_url");
  const serviceRequests = cartItem.get("service_requests", List());
  const isSelected = activeItem.value === cartItem.get("id");

  let mainDescription = cartItem.get("description");
  if (!mainDescription) {
    mainDescription = cartItem.get("shipment_tracking_number");
  }

  const handleCartItemClick = () => {
    const nextSelected = isSelected
      ? { value: "all" }
      : {
          value: cartItem.get("id"),
          label: cartItem.get("shipment_tracking_number"),
          image: cartItem.get("emblem_thumb_url"),
          description: cartItem.get("customer_comment"),
          serviceRequests: cartItem.get("service_requests"),
        };
    onActiveItemChange(nextSelected);
  };

  return (
    <ItemCompact onClick={handleCartItemClick} isSelected={isSelected}>
      {logoUrl ? <ItemLogo image={logoUrl} size={20} /> : <DefaultItemIcon />}
      <HeadTextCompact>{mainDescription}</HeadTextCompact>
      {serviceRequests.map((request: any) => {
        const iconUrl = request.getIn(["service_request_type", "icon", "url"]);
        const typeName = request.getIn(["service_request_type", "type"])?.toLowerCase();
        const mappedType = typeName ? requestNames[typeName as keyof typeof requestNames] : null;

        return (
          <ListItemCompact key={request.get("id")}>
            {iconUrl ? (
              <RasterIcon icon={iconUrl} size={[16, 16]} />
            ) : mappedType ? (
              <ServiceRequestIcon type={mappedType as IconType} />
            ) : null}
          </ListItemCompact>
        );
      })}
      {filteredItemAddons.map((id: string | number) => (
        <ListItemCompact key={id}>
          <ItemIcon>{getAddonsIconsImage(id, allAddons, 22)}</ItemIcon>
        </ListItemCompact>
      ))}
    </ItemCompact>
  );
};

export default React.memo(SideAddonItem);
